<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>UPDATE ORDER</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <!-- NAME -->
        <label class="vs-input--label">Delivery Address</label>
        <div class="ml-2">{{data.address_district}} {{data.address}} {{data.address_city}} {{data.address_region}} {{data.address_postcode}}</div>
        <div class="mt-5">
        <label class="vs-input--label">Customer Name</label>
        <div class="ml-2">{{data.address_full_name}}
        </div>
        <div class="mt-5">
          <label class="vs-input--label">Order Status</label>
          <v-select v-model="dataOrder_status" class="w-full rounded-lg cursor-pointer" placeholder="Select status" :options="order_status_choices" :clearable="false" name="order-status" v-validate="'required'" />
          <span class="text-danger text-sm" v-show="errors.has('order-status')">{{ errors.first('order-status') }}</span>

        </div>
        </div>
        <div class="mt-5">
        <label class="vs-input--label">Customer Phone Number</label>
        <div class="ml-2">{{data.address_phone}}
        </div>
        </div>

        <div class="mt-5 ">
        <label class="vs-input--label">Payment Type</label>
        <div class="ml-2">{{data.payment_type}}</div>
        </div>

        <div class="mt-5 ">
        <label class="vs-input--label">Delviery Type</label>
        <div class="ml-2">{{data.delivery_type_name}}</div>
        </div>

        <!-- CATEGORY -->

        <div class="mt-5">
          <label class="vs-input--label">Products</label>

          <div v-if="data.orderProduct.length > 0" :key="index" v-for="(product, index) in data.orderProduct" class="ml-2 mt-2">
            {{product.quantity}}x {{product.product_name}}
            <div v-if="product.modifier.length > 0" :key="m_index" v-for="(modifier, m_index) in product.modifier" class="ml-4">
                {{modifier.modifier_item_name}}
            </div>
          </div>
        </div>

        <div class="mt-5 ">
          <label class="vs-input--label">Order Date</label>
          <div class="ml-2">{{data.order_date}}</div>
        </div>

        <div class="mt-5 ">
          <label class="vs-input--label">Total Amount</label>
          <div class="ml-2">{{data.total_amount}}</div>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    vSelect
  },
  data () {
    return {

      dataId: null,
      dataName: '',
      dataCategory: null,
      dataImg: null,
      dataOrder_status: {labell:'Select', value:-1},
      dataPrice: 0,

      category_choices: [
        {text:'Audio', value:'audio'},
        {text:'Computers', value:'computers'},
        {text:'Fitness', value:'fitness'},
        {text:'Appliance', value:'appliance'}
      ],

      order_status_choices: [],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      this.resetStatuses()
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        this.setStatuses()
        const { id, status } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataOrder_status = this.getOrderStatus(status)
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any()
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    orderStatuses () {
      return this.$store.state.api.orderStatuses
    }
  },
  methods: {
    resetStatuses () {
      this.order_status_choices = []
    },
    getOrderStatus (id) {
      const item = this.orderStatuses.find(x => x.id === id)

      return {
        label: item.name,
        value: item.id
      }
    },
    setStatuses () {
      this.orderStatuses.map((child) => {
        const item = {
          label:child.name,
          value:child.id
        }
        this.order_status_choices.push(item)
      })
    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataName = ''
      this.dataCategory = null
      this.dataOrder_status = ''
      this.dataPrice = 0
      this.dataImg = null
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            orderId: this.dataId,
            status: this.dataOrder_status.value
          }

          this.$store.dispatch('api/setOrderStatus', obj)
            .then(() => {
              this.$emit('closeSidebar')
              this.initValues()
            })
            .catch(err => {
              console.error(err)
            })

        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
</style>
